import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import * as firebase from 'firebase';
import { AlertService } from '../../../_services/alert.service';
import { v4 as uuidv4 } from 'uuid';
import * as _ from 'underscore';
import Swal from 'sweetalert2/dist/sweetalert2.js';
@Component({
  selector: 'app-others-activity',
  templateUrl: './others-activity.component.html',
  styleUrls: ['./others-activity.component.css']
})
export class OthersActivityComponent implements OnInit {
  modalRef: any;
  iconTab: FormGroup;
  meals = ['Yes', 'No'];
  members = ['Walter White', 'Jessy Pinkman', 'Heisenberg', 'Skylar White', 'Saul Goodman']
  modes = ['Bus', 'Train']
  mealTypes = ['Personal', 'Client', 'Team']
  mealSession = ['Breakfast', 'Lunch', 'Dinner', 'Others']

  private activityList: Array<any> = [];
  tagList = [];
  isLoading: any = false;
  isUploading: any = false;
  selectedItems = [];
  snapList: any = [];
  diffList = [];
  dropdownSettings = {};
  keyIndex: any = -1;
  minDate: any;
  maxDate: any;
  startDate: any;
  currMinDate: any;
  currMaxDate: any;
  addedBy: any;
  verifyFields = [
    {
      "key": "description",
      "value": "Description"
    },
    {
      "key": "othersStartDate",
      "value": "OthersStartDate",
      "isDate": true
    },
    {
      "key": "othersEndDate",
      "value": "OthersEndDate",
      "isDate": true
    },
    {
      "key": "purpose",
      "value": "Purpose"
    },
    {
      "key": "startTimeOthers",
      "value": "StartTimeOthers"
    },
    {
      "key": "endTimeOthers",
      "value": "EndTimeOthers"
    },
    {
      "key": "tagMembersOthers",
      "value": "TagMembersOthers"
    },
    {
      "key": "paidbyOthers",
      "value": "PaidbyOthers"
    },
    {
      "key": "otherInfoOthers",
      "value": "OtherInfoOthers"
    },
    {
      "key": "transNumberOthers",
      "value": "TransNumberOthers"
    },
    {
      "key": "merchNameOthers",
      "value": "MerchNameOthers"
    }
  ]

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private alertService: AlertService
  ) {
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth(),
      day: current.getDate(),
    };
  }

  @Input() data: any;
  @Input() travellers: any;
  @Input() createdBy: any;
  @Input() code: any;
  @Input() isReadOnly: any;
  @Input() isDisabled: any;
  @Input() isActivityEdit: any;
  @Output() flightData: EventEmitter<any> = new EventEmitter()

  ngOnInit(): void {
    this.iconTab = this.formBuilder.group({
      activityDetails: [[]],

      // others Activity
      description: ['', Validators.required],
      purpose: ['', Validators.required],
      othersStartDate: ['', Validators.required],
      othersEndDate: ['', Validators.required],
      othersStart: ['', Validators.required],
      othersEnd: ['', Validators.required],
      startTimeOthers: ['', Validators.required],
      endTimeOthers: ['', Validators.required],
      paidbyOthers: ['', Validators.required],
      tagMembersOthers: ['', Validators.required],
      otherInfoOthers: ['', Validators.required],
      transNumberOthers: ['', Validators.required],
      merchNameOthers: ['', Validators.required],
      createdBy: ['', Validators.required],
    });

    this.tagList = this.travellers;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.iconTab.patchValue(this.data);
    this.addedBy = this.data ? this.data.createdBy : this.createdBy;
    this.createdBy = this.data ? this.data.createdBy : this.createdBy + " - " + this.code;
    this.snapList = this.data ? this.data.snapList : '' || [];
    this.diffList = this.data && this.data.activityDiffList || [];
    this.selectedItems = this.data ? this.data.tagMembersOthers : '' || [];
    console.log('diffList --', this.diffList)
  }

  get f() {
    return this.iconTab.controls;
  }

  getDiffItem(key: any, val: any) {
    let d = _.groupBy(this.diffList, 'key')[key]
    if (d && d.length) {
      return d[0][val]
    }
  }

  displayMembers(allMembers: any) {
    console.log(allMembers);
    allMembers = allMembers.toString().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ',  ');
    return allMembers;
  }

  othersActivity() {
    this.activityList.push({
      category: "Others",
      description: this.iconTab.value.description,
      othersStartDate: this.iconTab.value.othersStartDate,
      othersEndDate: this.iconTab.value.othersEndDate,
      othersStart: this.iconTab.value.othersStart,
      othersEnd: this.iconTab.value.othersEnd,
      startTimeOthers: this.iconTab.value.startTimeOthers,
      endTimeOthers: this.iconTab.value.endTimeOthers,
      paidbyOthers: this.iconTab.value.paidbyOthers,
      tagMembersOthers: this.iconTab.value.tagMembersOthers,
      otherInfoOthers: this.iconTab.value.otherInfoOthers,
      transNumberOthers: this.iconTab.value.transNumberOthers,
      merchNameOthers: this.iconTab.value.merchNameOthers,
    })
    this.iconTab.patchValue({
      activityDetails: this.activityList,
      category: "Others",
      description: '',
      othersStartDate: '',
      othersEndDate: '',
      othersStart: '',
      othersEnd: '',
      startTimeOthers: '',
      endTimeOthers: '',
      paidbyOthers: '',
      tagMembersOthers: '',
      otherInfoOthers: '',
      transNumberOthers: '',
      merchNameOthers: '',
    })
  }

  editOthersActivity(index, content) {
    this.modalRef = this.modalService.open(content, { windowClass: 'animated fadeInDown', size: 'lg' });
    this.keyIndex = index;
    this.iconTab.patchValue({
      description: this.activityList[index].description,
      othersStartDate: this.activityList[index].othersStartDate,
      othersEndDate: this.activityList[index].othersEndDate,
      othersStart: this.activityList[index].othersStart,
      othersEnd: this.activityList[index].othersEnd,
      startTimeOthers: this.activityList[index].startTimeOthers,
      endTimeOthers: this.activityList[index].endTimeOthers,
      paidbyOthers: this.activityList[index].paidbyOthers,
      tagMembersOthers: this.activityList[index].tagMembersOthers,
      otherInfoOthers: this.activityList[index].otherInfoOthers,
      transNumberOthers: this.activityList[index].transNumberOthers,
      merchNameOthers: this.activityList[index].merchNameOthers,
    });
    this.selectedItems = this.activityList[index].tagMembersOthers
  }

  upDateOthersActivity() {
    this.activityList[this.keyIndex] = {
      category: 'Others',
      description: this.iconTab.value.description,
      othersStartDate: this.iconTab.value.othersStartDate,
      othersEndDate: this.iconTab.value.othersEndDate,
      othersStart: this.iconTab.value.othersStart,
      othersEnd: this.iconTab.value.othersEnd,
      startTimeOthers: this.iconTab.value.startTimeOthers,
      endTimeOthers: this.iconTab.value.endTimeOthers,
      paidbyOthers: this.iconTab.value.paidbyOthers,
      tagMembersOthers: this.iconTab.value.tagMembersOthers,
      otherInfoOthers: this.iconTab.value.otherInfoOthers,
      transNumberOthers: this.iconTab.value.transNumberOthers,
      merchNameOthers: this.iconTab.value.merchNameOthers,
    };

    this.iconTab.patchValue({
      activityDetails: this.activityList,
      description: '',
      othersStartDate: '',
      othersEndDate: '',
      othersStart: '',
      othersEnd: '',
      startTimeOthers: '',
      endTimeOthers: '',
      paidbyOthers: '',
      tagMembersOthers: '',
      otherInfoOthers: '',
      transNumberOthers: '',
      merchNameOthers: '',
    });
    this.keyIndex = -1;
  }

  selectOthersStartDate(event) {
    console.log(event);
    this.startDate = event;
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      othersStartDate: finalDate
    })
    this["othersStart"] = finalDate;
  }

  selectOthersEndDate(event) {
    console.log(event);
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      othersEndDate: finalDate
    })
    this["othersEnd"] = finalDate;
  }


  getMinDate() {
    if (this.startDate) {
      return (this.startDate)
    } else {
      return this.minDate
    }
  }

  readableDateFormat(userDate: any) {
    if (!_.isObject(userDate)) {
      return userDate;
    } else {
      let year = userDate.year;
      let month = userDate.month <= 9 ? '0' + userDate.month : userDate.month;;
      let day = userDate.day <= 9 ? '0' + userDate.day : userDate.day;;
      let finalDate = day + "-" + month + "-" + year;
      return finalDate;
    }
  }

  addNewItem() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Save?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        if (!this.iconTab.value.description || !this.iconTab.value.purpose || !this.iconTab.value.othersStart
          || !this.iconTab.value.startTimeOthers || !this.iconTab.value.othersEnd
          || this.iconTab.value.tagMembersOthers.length == 0) {
          this.alertService.showError('Mandatory fields to be filled !');
          return false;
        }

        let isMatch = _.isMatch(this.data, this.iconTab.value);
        if (isMatch && this.isActivityEdit) {
          this.alertService.showError('No Changes made to amend !', 3000, 'Invalid update !')
          return false;
        }

        let activityDiffList = [];
        if (!isMatch && this.isActivityEdit) {
          let that = this;
          let old = _.clone(this.data), fresh = _.clone(this.iconTab.value);
          _.each(this.verifyFields, function(field) {
            let newVal = fresh[field.key], oldVal = old[field.key];
            if (old[field.key] != fresh[field.key]) {

              // if (field.key == 'meals' && newVal == 'No') {
              //   newVal = fresh['meals']
              // } else {
              //   newVal = fresh['meals']
              // }

              activityDiffList.push({
                key: field.key,
                name: field.value,
                oldVal: field.isDate ? that.readableDateFormat(old[field.key]) : oldVal,
                newVal: field.isDate ? that.readableDateFormat(fresh[field.key]) : newVal
              })
            }
          })
        }

        console.log('am in addNewItem ', activityDiffList, this.activityList, this.iconTab.value);
        this.flightData.emit({ ...this.iconTab.value, activityDiffList: activityDiffList, key: this.code, snapList: this.snapList, category: 'Others', uniqueId: uuidv4(), addedBy: this.addedBy });
        this.closeModal();
      }
    })
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  chooseFile() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Upload Confirmation Doc?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        document.getElementById("avatar").click();
      }
    })
  }

  upload() {
    // Create a root reference
    let storageRef = firebase.storage().ref();
    this.isUploading = true;
    let that = this;

    for (let selectedFile of [(<HTMLInputElement>document.getElementById('avatar')).files[0]]) {
      // let path = '/BILLS/' + Date.now() + `${selectedFile.name}`;
      let path = '/BILLS/' + Date.now() + '_' + `${selectedFile.name}`;
      let iRef = storageRef.child(path);
      iRef.put(selectedFile).then((snapshot) => {
        snapshot.ref.getDownloadURL()
          .then((url) => {
            let images = that.snapList || [];
            images.push(url);
            that.snapList = images;
            this.isUploading = false;
          })
      });
    }
  }

  removeImage(index: any) {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Remove?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.snapList.splice(index, 1);
      }
    })
  }

  getFileName(url: any) {
    let data = '';
    if (url.split('_')[1]) {
      data = url.split('_')[1].split('?');
      data = data[0] ? decodeURI(data[0]) : '';
      return data;
    } else {
      return data;
    }
  }

}
